import { BObjectModel } from '../bodisplay';
import { QueovalBase, InfoBo, QueovalDate } from '../global';
import { Model, LearnerDetail } from '../questionnaire';
import { EstoreLicenseModel, EstoreModel, PrivateClientInfo } from '../estore';
import { Select } from '../utilities';


/**
 * Chapitre
 */
export class Chapter {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Titre
   */
  public Title: string;
  /**
   * Description
   */
  public Description: string;
  /**
   * S'il est coché
   */
  public IsChecked: boolean;
  /**
   * Image
   */
  public strImage: string;
  /**
   * Temps (théorique sur le chapitre)
   */
  public Time: string;
  /**
   * Objectif
   */
  public Objective: string;
  /**
   * Avancement
   */
  public Avancement: number;
  /**
   * Ordre
   */
  public Ordre: number;
  /**
   * S'il doit être affiché
   */
  public IsShow: boolean;
  /**
   * Catalogue associé
   */
  public AssociatedCatalog: string;
  /**
   * Si c'est un chapitre scorm (plus utile)
   */
  public IsScorm: boolean;
  /**
   * Url du scorm (plus utile)
   */
  public ScormUrl: string;
  /**
   * Code auteur
   */
  public CodeAuthor: string;
  /**
   * Code groupe E-Learning
   */
  public CodeGroupeEL: string;
  /**
   * Code groupe E-Learning
   */
  public VersionES: string;
  /**
  * Liste des cycles associés (directement en chaine de caractère)
  */
  public StrLstAssociatedCycle: string;
}

/* --------------------- LESSONS --------------------------------- */
/**
 * Module (= partie -> regroupement de leçons) --- PLUS UTILISE...
 */
//export class Module {
//  /**
//   * Ident
//   */
//  public Ident: string;
//  /**
//   * Code
//   */
//  public Code: string;
//  /**
//   * Nom
//   */
//  public Name: string;
//  /**
//   * Liste des leçons
//   */
//  public ListLesson: Lesson[];
//  /**
//   * Avancement
//   */
//  public Avancement: number;
//}

/**
 * Leçon (ou module pour le nommage)
 */
export class Lesson {
  /**
   * Ident
   */
  public Ident: string;
  /**
  * Titre
  */
  public Title: string;
  /**
  * Description
  */
  public Description: string;
  /**
  * Code du module
  */
  public CodeModule: string;
  /**
  * Nom du module
  */
  public NameModule: string;
  /**
  * Si elle est validée
  */
  public IsValidate: boolean;
  /**
  * Ordre
  */
  public Order: number;
  /**
  * Si elle est publique
  */
  public IsPublic: boolean;
  /**
  * Ident de la leçon précédente
  */
  public IdPrevLesson: string;
  /**
  * Ident de la leçon suivante
  */
  public IdNextLesson: string;
  /**
  * Si elle doit être affichée
  */
  public IsShow: boolean;
  /**
  * Si elle est sélectionnée
  */
  public IsSelected: boolean;
  /**
  * Type
  */
  public Type: string;
  /**
  * Catégorie
  */
  public Categorie: string;
  /**
  * Thématique
  */
  public Thematic: string;
  /**
  * Informations
  */
  public Infos: string;
  /**
  * Diffusion
  */
  public Diffusion: string;
  /**
  * Auteur
  */
  public Author: string;
  /**
  * Date de création
  */
  public CreationDate: Date;
  /**
  * Contenu Html
  */
  public ContentHtml: string;
  /**
  * Vidéo
  */
  public Video: string;
  /**
  * Type de vidéo
  */
  public TypeVideo: string;
  /**
  * Si elle a un scorm externe
  */
  public HasExternalScorm: boolean;
  /**
  * Type de document
  */
  public TypeDocument: string;
  /**
  * Document
  */
  public Document: string;
  /**
  * Questionnaire
  */
  public Questionnaire: string;
  /**
  * Ident Questionnaire
  */
  public IdQuestionnaire: string;
  /**
   * Message de fin du questionnaire
   */
  public MsgFinQuestValidation: string
  /**
   * Pour savoir si l'apprenant a répondu au questionnaire
   */
  public ExoCompleted: boolean
  /**
  * Exercice
  */
  public Exercice: string;
  /**
 * Ident Exercice
 */
  public IdExercice: string;
  /**
  * Formateur
  */
  public Trainer: Trainer;
  /**
  * Si c'est la leçon "courante"
  */
  public IsCurrentLesson: boolean;
  /**
  * Temps avant d'afficher le test de validation
  */
  public TimeBeforeValid: number;
  /**
  * Avancement dans la leçon
  */
  public Avancement: AvancementLess;

  // #region BLINDED

  /**
   * Pour savoir s'il est possible d'accéder à la validation du module
   */
  public AllowValid: boolean;
  /**
   * Réservation Blinded Inter choisie par l'apprenant
   */
  public ReservationInterSelected: ReservBlInter;
  /**
   * Liste des réservation blinded Inter disponibles
   */
  public ListReservationsInter: ReservBlInter[];

  /*
   * Pour savoir si une réseration blinded intra est prévue
   */
  public HasReservIntra: boolean;

  /*
   * Date réservation blinded Intra
   */
  public DateReservIntra: Date;

  // #endregion

  // #region détail Questionnaire

  public DetailQuestionnaires: Array<Questionnaire>;

  // #region leçon e-store

  /**
   * Clé auteur E-Store
   */
  public AuthorKeyES: string;

  // #endregion

  // #endregion
}

/**
 * Avancement dans la leçon
 */
export class AvancementLess {
  /**
   * Si le texte de la leçon a été vu
   */
  public TxtLessChecked: boolean;
  /**
   * Si la modale de la vidéo a été ouverte
   */
  public VideoChecked: boolean;
  /**
   * Si l'exercice a été vu
   */
  public ExercChecked: boolean;
  /**
   * Si le document a été téléchargé
   */
  public DocChecked: boolean;
  /**
   * Si le test de validation a été vu
   */
  public QuestChecked: boolean;
  /**
   * Notes / commentaires sur le module (Html)
   */
  public NotesHtml: string | null;
  /**
   * Numéro correspondant à l'avis
   */
  public NumAvis: number;
}

/* ---------------------- FORMATEUR  ------------------------------ */

/**
 * Formateur
 */
export class Trainer {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Civilité
   */
  public Civility: string;
  /**
   * Nom
   */
  public Name: string;
  /**
   * Prénom
   */
  public FirstName: string;
  /**
   * Mail
   */
  public Mail: string;
  /**
   * Image
   */
  public StrImage: string;
  /**
   * Question posée
   */
  public QuestionAsked: string;
}

export class ReservBlInter {
  public Ident: string;
  public Titre: string;
  public DateDebut: Date;
  public DateFin: Date;
  public Duree: number;
  public IdStage: string;
  public NbHoursToModif: number;
  public strListUrlZoom: string;
}

/* ------------------------- CYCLES--------------------------------------- */

/**
 * Cycle E-Learning
 */
export class CycleEL {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Code
   */
  public Code: string;
  /**
   * Nom
   */
  public Name: string;
  /**
   * Liste des chapitres
   */
  public ListChapter: Chapter[];
  /**
   * Liste des questionnaires formation
   */
  public Questionnaire: QuestionnaireFormation[];
  /**
   * Image
   */
  public Image: string;

  // Pour l'affichage
  /**
    S'il a été modifié
   */
  public HasChanged: boolean;
  /**
   * S'il est coché
   */
  public IsChecked: boolean;
}

/**
 * Classe pour les questionnaires sur un cycle E-Learning
 */
export class QuestionnaireFormation {
  /**
   * Code
   */
  public Code: string;
  /**
   * Titre
   */
  public Titre: string;
  /**
   * Id du stage sur lequel se trouve le questionnaire
   */
  public IdStageForQuestionnaire: string;
}

/* ---------------------- ADMIN  -------------------------------- */
/**
 * Catalogue E-Learning
 */
export class CatalogueEL {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Nom du catalogue
   */
  public Name: string;
  /**
   * Description
   */
  public Description: string;
}

/* ---------------------- USERS  -------------------------------- */

/**
 * Utilisateur E-Learning
 */
export class UserEL {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Prénom
   */
  public FirstName: string;
  /**
   * Nom
   */
  public Name: string;
  /**
   * Mail
   */
  public Mail: string;
  /**
   * Nom de connexion
   */
  public CnxName: string;
  /**
   * Mot de passe
   */
  public PassWord: string;
  /**
   * Cycle (plus utile)
   */
  //public Cycle: string;
  /**
   * Rôle
   */
  public Role: string;
  /**
   * Liste des cycles
   */
  public ListCycles: CycleEL[];
}

/* ---------------------- MODEL MAILS  -------------------------------- */
/**
// * Modèle de mail --- ANCIENNE VERSION
//// */
//////export class ModelMail {
//////  public CkeditorVersion: string;
//////  public To: Array<string>;
//////  /**
//////   * Ident
//////   */
//////  public Ident: string;
//////  /**
//////   * Code du modèle
//////   */
//////  public CodeModel: string;
//////  /**
//////   * Infos du modèles
//////   */
//////  public InfoModel: string;
//////  /**
//////   * Contenu du mail
//////   */
//////  public ContentMail: string;
//////  /**
//////   * Mail de l'expéditeur
//////   */
//////  public SenderMail: string;
//////  /**
//////   * Objet
//////   */
//////  public Object: string;
//////  /**
//////   * CC
//////   */
//////  public CC: Array<string>;
//////  /**
//////   * CCI
//////   */
//////  public CCI: Array<string>;
//////  /**
//////   * Si c'est le modèle par défaut
//////   */
//////  public IsDefault: boolean;

//////  constructor() {
//////    this.CodeModel = '';
//////    this.ContentMail = '';
//////    this.To = [];
//////    this.CC = [];
//////    this.CCI = [];
//////  }
//////}

/* ---------------------- BO OBJECT  -------------------------------- */
/**
 * BO
 */
export class BoObject {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Code
   */
  public Code: string;
  /**
   * Nom
   */
  public Name: string;
  /**
   * Liste des propriétés
   */
  public ListProperties: PropertyObject[];
  /**
   * S'il a une propriété sélectionnée
   */
  public HasPropSelected: boolean;
  /**
   * Propriété sélectionnée
   */
  public PropSelected: PropertyObject;
  /**
   * Format sélectionné
   */
  public FormatSelected: FormatOption;
}

/**
 * Propriété d'un BO
 */
export class PropertyObject {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Code
   */
  public Code: string;
  /**
   * Nom
   */
  public Name: string;
  /**
   * Type
   */
  public Type: string;
  /**
   * Méthode
   */
  public Methode: string;
  /**
   * Liste des formats
   */
  public ListFormatOption: FormatOption[];
}

/**
 * Format d'une propriété
 */
export class FormatOption {
  /**
   * Type de propriété (nvarchar, integer, date...)
   */
  public DbType: string;
  /**
   * Texte (nom du format)
   */
  public Text: string;
  /**
   * Valeur
   */
  public Value: string;
}

/* ---------------------- PARAMETRAGE  -------------------------------- */
/**
 * Loge E-Learning
 */
export class LogoEL {
  /**
   * Ancien chemin
   */
  public oldPath: string;
  /**
   * Image
   */
  public strImage: string;
  /**
   * Chemin
   */
  public path: string;
}

/**
 * Réseaux sociaux
 */
export class SocialNetworks {
  /**
   * Lien Facebook
   */
  public FacebookLink: string;
  /**
   * Lien Twitter
   */
  public TwitterLink: string;
  /**
   * Lien Youtube
   */
  public YoutubeLink: string;
  /**
   * Lien Google +
   */
  public GooglePlusLink: string;
  /**
   * Lien LinkedIn
   */
  public LinkedInLink: string;
  /**
   * Lien Viadeo
   */
  public ViadeoLink: string;
}

/* ---------------------- SCORM  -------------------------------- */

export class Scorm {
  public ListSite: Site[];
}

export class Site {
  public Url: string;
  public Folder: string;
}

/* ---------------------- COMMON  -------------------------------- */


/**
 * Routes de l'application
 */
export class AppRoutes {
  /**
   * Page d'accueil
   */
  readonly HOME: string = '/webform/elearning/home';
  /**
   * Page des chapitres
   */
  readonly CHAPTERS: string = '/webform/elearning/chapters';
  /**
   * Page d'administration des leçons (OLD VERSION)
   */
  readonly ADMIN: string = '/webform/admin/lesson';
  /**
   * Page d'administration des modules (NEW VERSION)
   */
  readonly ADMINMODULE: string = '/webform/admin/module';
  /**
   * ESTORE
   */
  readonly ESTORE: string = '/webform/admin/estore';
  readonly ESTOREDETAILS: string = '/webform/admin/estoredetails';
  /**
   * Page de gestion des cycles
   */
  readonly CYCLES: string = '/webform/admin/cycles';
  /**
   * Page d'administration des questionnaires
   */
  readonly ADMINQUEST: string = '/webform/questionnaire/modelCreation';
  /**
   * Page d'administration des résultats des questionnaires
   */
  readonly RESULTQUEST: string = '/webform/questionnaire/result';
  /**
   * Page de gestion des apprenants
   */
  readonly ADMINUSERS: string = '/webform/license/licenseUsers';
  /**
   * Page de gestion des modèles de mail
   */
  readonly MODELMAIL: string = '/webform/license/modelMail';
  /**
   * Page statistiques
   */
  readonly STATS: string = '/webform/statistic/statistic';
  /**
   * Page de modification du mot de passe
   */
  readonly CHANGEPASSWORD: string = '/webform/password/changePassword';
  /**
   * Page des paramètres de l'application
   */
  readonly CONFIGURATION: string = '/webform/configuration/globalConfig';
}

/* ------------------------------------------------------ */

/**
 * Modèle de l'historique de (pour le calcule du temps passé)
 */
export class HistoryModel extends QueovalBase {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Id de l'apprenant
   */
  public LearnerId: string;
  /**
   * Id du cycle EL
   */
  public CycleId: string;
  /**
   * Id du chapitre
   */
  public ChapterId: string;
  /**
   * Id de la leçon
   */
  public LessonId: string;
  /**
   * Temps passé
   */
  public Time: number;
  /**
   * Intervalle de temps
   */
  public IntervalTime: number;
  /**
   * Heure précise de l'ouverture de la modale vidéo
   */
  public TimeStartVideo: Date;
  /**
   * Heure précise de fermeture de la modale vidéo
   */
  public TimeEndVideo: Date;
}

/* ------------------------------------------------------ */

/**
 * Classe permettant de stocker les infos de l'utilisateur connecté
 */
export class DataSessionItem {
  /**
   * Ident
   */
  id: string;
  /**
   * Code
   */
  code: string;
  /**
   * Description
   */
  desc: string;
  /**
   * Utilisateur
   */
  user: string;
  /**
   * Données (format JSON)
   */
  jsData: string;
}

/**
 * Classe permettant de stocker les infos utiles afin de les garder lors de la navigation
 */
export class DataSession {
  /**
   * Données du cycle
   */
  cycle: DataSessionItem;
  /**
   * Données du chapitre
   */
  chapter: DataSessionItem;
  /**
   * Données de la leçon (ou module)
   */
  lesson: DataSessionItem;
  /**
   * Constructeur
   */
  constructor() {
    this.cycle = new DataSessionItem();
    this.chapter = new DataSessionItem();
    this.lesson = new DataSessionItem();
  }
}

/**
 * Paramètre globaux à l'ensemble de l'application
 */
export class ELParams {
  /**
   * Si l'utilisateur a "réagi"
   */
  isReact: boolean;
  /**
   * Chaine d'entrée (si l'on vient de l'extranet par exemple)
   */
  //////////queryString: string;
  /**
   * Si la page de login doit être affichée
   */
  //////////affichePageLogin: boolean;
  /**
   * Type de fichier à ajouter
   */
  typeFileToAdd: string;
  /**
   * Si un fichier a été chargé
   */
  fileUploaded: boolean;
  /**
   * Si un lien a été sauvegardé
   */
  linkSaved: boolean;
  /**
   * Nouveau fichier sélectionné
   */
  newFileSelected: string;
  /**
   * Type de vidéo
   */
  typeVideo: string;
  /**
   * Reload type de vidéo
   */
  reloadTypeVideo: boolean;
  /**
   * Type de média (vidéo ou scorm)
   */
  typeMedia: string;
  /**
   * Type de document
   */
  typeDoc: string;
  /**
   * Si le type de vidéo a été sauvegardé
   */
  typeVideoIsSaved: boolean;
  /** Si le type de document a été sauvegardé
   *
   */
  typeDocIsSaved: boolean;
  /** Si le scorm a été selectionné
   *
   */
  scormIsSelected: boolean;
  /**
   * Url de la vidéo
   */
  urlVideo: string;
  /**
   * Url du document
   */
  urlDoc: string;
  /**
   * Si la leçon a été ajoutée au chapitre
   */
  lessonAddedToChapter: boolean;
  /**
   * Intervalle de temps
   */
  intervalleTime: number;
  /**
   * Si la vidéo a été vue
   */
  isWatchVideo: boolean;
  /**
   * Données de l'utilisateur
   */
  userData: UserDataModel;
  /**
   * Routes de l'application
   */
  appRoutes: AppRoutes;
  /**
   * Données sauvegardée en session
   */
  dataSession: DataSession;
  /**
   * Droits E-Learning
   */
  droitELearning: DroitEl;
  // Droit EStore
  droitEstore: DroitEstore;
  /**
   * Booleen pour afficher la div "Scorm" dans la modale addFile
   */
  public showDivScorm: boolean;

  /**
   * Leçon sélectionnée dans page d'administration
   */
  public currentLesson: Lesson;
  /**
   * Liste des leçons dans page d'administration
   */
  public listLessons: Lesson[];

  /**
   * Mode visualisation dans page d'administration
   */
  public modeVisu: boolean;

  /**
   * Code de la page ouverte
   */
  public codeCurrentPage: string;


  //#region EStore data management

  // estore token data
  EstoreData: EstoreModel;
  //////// estore license data (JSON.stringify of LicenseModel)
  //////EstoreLicense: string;
  //////// author code for estore management
  //////EstoreAuthor: string;

  //#endregion


  constructor() {
    this.isReact = false;
    //////////this.queryString = '';
    //////////this.affichePageLogin = false;
    // FILES
    this.typeFileToAdd = '';
    this.fileUploaded = false;
    this.linkSaved = false;
    this.newFileSelected = '';
    this.typeVideo = '';
    this.typeMedia = 'VIDEO';
    this.typeDoc = '';
    this.typeVideoIsSaved = false;
    this.typeDocIsSaved = false;
    this.scormIsSelected = false;
    this.urlVideo = '';
    this.urlDoc = '';
    this.lessonAddedToChapter = false;
    // Intervalle pour calculer le temps passé sur une leçon
    this.intervalleTime = 60000;
    this.isWatchVideo = false;
    this.appRoutes = new AppRoutes();
    this.userData = new UserDataModel();
    this.dataSession = new DataSession();
    this.droitELearning = new DroitEl();
    this.droitEstore = new DroitEstore();
    this.showDivScorm = false;
    this.currentLesson = new Lesson();
    this.modeVisu = false;
    this.codeCurrentPage = '';
  }
}


/**
 * Classes des droits E-Learning
 */
export class DroitEl {
  /**
   * Droit d'accès à l'application
   */
  AccesEl: Boolean;
  /**
   * Droit d'accès à la page d'administration des leçons
   */
  gestionLeconEl: Boolean;
  /**
   * Droit d'accès à la page de gestion des apprenants (des licences)
   */
  gestionLicenceEl: Boolean;
  /**
   * Droit d'accès à la page des paramétrages
   */
  parametrageEl: Boolean;
  /**
   * Constructeur
   */
  constructor() {
    this.AccesEl = false;
    this.gestionLeconEl = false;
    this.gestionLicenceEl = false;
    this.parametrageEl = false;
  }
}

export class DroitEstore {
  // Droit d'accès à l'application
  AccesApp: boolean;
  // Droit d'accès à publier du contenu
  PublishContent: boolean;
  // Droit d'accès à telecharger du contenu
  DownloadContent: boolean;
  constructor() {
    this.AccesApp = false;
    this.PublishContent = false;
    this.DownloadContent = false;
  }
}

/* ------------------------------------------------------ */


/**
 * Modèle de l'utilisateur connecté
 */
export class UserDataModel extends QueovalBase {
  /**
   * Prénom
   */
  public FirstName: string;
  /**
   * Nom
   */
  public Name: string;
  /**
   * Nom de connexion de l'utilisateur
   */
  public cnxUserName: string;
  /**
   * Ident dans Queoval
   */
  public userQueovalId: string;
  /**
   *Profil de l'utilisateur
   */
  public userProfil: string;
  /**
   * Lien Facebook
   */
  public facebookLink: string;
  /**
   * Lien Twitter
   */
  public twitterLink: string;
  /**
   * Lien Viadeo
   */
  public viadeoLink: string;
  /**
   * Lien Youtube
   */
  public youtubeLink: string;
  /**
   * Lien LinkedIn
   */
  public linkedInLink: string;
  /**
   * Logo E-Learning
   */
  public strLogoEL: string;
  /**
   * Logo de la connection de l'application
   */
  public strLogoConnectEL: string;
  /**
   * Theme
   */
  public Theme: string;
  /**
   * Si son E-Learning est expiré
   */
  public IsExpiredEL: boolean;
  /**
   * Base sur laquelle on est connecté
   */
  public BaseName: string;
  /**
   *  estore license data
   */
  public EstoreLicense: EstoreLicenseModel;
  /**
   * author code for estore management
   */
  public EstoreAuthor: string;
  /**
   * Code groupe E-Learning (pour les formateurs allant dans l'administration des chapitres)
   */
  public CodeGroupeEL: string;

  /**
   * Constructeur
   */
  constructor() {
    super();
    this.FirstName = '';
    this.Name = '';
    this.cnxUserName = '';
    this.userQueovalId = '';
    this.userProfil = '';
    this.facebookLink = '';
    this.twitterLink = '';
    this.viadeoLink = '';
    this.youtubeLink = '';
    this.linkedInLink = '';
    this.strLogoEL = '';
    this.strLogoConnectEL = '';
    this.Theme = '';
    this.IsExpiredEL = false;
    this.CodeGroupeEL = '';
  }
}

/* ------------------------------------------------------ */
/**
 * Modèle de la page des chapitres
 */
export class ChaptersModel extends QueovalBase {
  /**
   * Cycle E-Learning
   */
  public CycleEL: CycleEL;
  /**
   * Chapitre sélectionné
   */
  public ChapterSelected: Chapter;
  /**
   * Liste des catalogues utilisés (regroupement des catalogues des chapitres)
   */
  public CatalogsListUsed: CatalogueEL[];
  /**
   * Questionnaire à faire (sur le cycle)
   */
  public QuestionnaireToDo: QuestionnaireFormation;
  /**
   * Si le cycle est affecté à l'apprenant
   */
  public CycleIsAffected: boolean;
  /**
   * Liste des cycles E-Learning
   */
  public ListCycleEL: CycleEL[];
}

/* ------------------------------------------------------ */
/**
 * Modèle de la page des leçons
 */
export class LessonsModel extends QueovalBase {
  /**
   * Liste des modules (= des parties regroupant les leçons) --- PLUS UTILISE...
   */
  //////public ListModule: Module[];
  /**
   * Leçon sélectionnée
   */
  public LessonSelected: Lesson;
  /**
   * Ident de l'apprenant
   */
  public LearnerId: string;
  /**
   * Ident du cycle
   */
  public CycleId: string;
  /**
   * Ident du chapitre
   */
  public ChapterId: string;
  /**
  * Titre (ou nom) du chapitre
  */
  public ChapterName: string;
  /**
   * Si toutes les leçons sont validées
   */
  public AllValidate: boolean;
  /**
   * Si tous les modules sont "vides" (ne contiennent aucune leçon)
   */
  public AllModulesEmpty: boolean;
  /**
   * Liste de toutes les leçons
   */
  public ListAllLessons: Lesson[];
  /**
  * Numéro correspondant au code de l'avis (pour modèle temporaire à la validation)
  */
  public codeAvis: number;

}

/* ---------------------- ADMIN  -------------------------------- */
/**
 * Modèle de la page d'administration des chapitres / leçons
 */
export class AdminModel extends QueovalBase {
  /**
   * Liste des catalogues E-Learning
   */
  public ListCatalogueEL: CatalogueEL[];
  /**
   * Liste des chapitres
   */
  public ListChapters: Chapter[];
  /**
   * Chapitre sélectionné
   */
  public ChapterSelected: Chapter;
  /**
   * Liste des leçons
   */
  public ListLessons: Lesson[];
  /**
   * Liste des modules (= parties : ensemble des leçons) --- PLUS UTILISE...
   */
  //////public ListModules: Module[];
  /**
   * Liste des "autres" leçons (celles qui ne sont pas dans un chapitre)
   */
  public ListOthersLessons: Lesson[];
  /**
   * Code du module
   */
  public CodeModule: string;
  /**
   * Leçon sélectionnée
   */
  public LessonSelected: Lesson;
  /**
   * Info du BO Catalogue E-Learning
   */
  public InfoBOCatalogueEL: InfoBo;
  /**
   * Info du BO Chapitre
   */
  public InfoBOChapter: InfoBo;
  /**
   * Info du BO Leçon (BO_CONNAISSANCE)
   */
  public InfoBOLesson: InfoBo;
  /**
   * Liste des modèles de questionnaires
   */
  public listModelsQuestionnaires: Model[];
  /**
   * Liste des modèles d'exercice
   */
  public listModelsExercices: Model[];
  /**
   * Liste des formateurs
   */
  public ListTrainers: Trainer[];
  /**
   * Info du BO Formateur
   */
  public InfoBOTrainer: InfoBo;
  /**
   * Si le chapitre contient des leçons
   */
  public ChapterContainsLessons: boolean;
  /**
 * Liste des types disponibles pour un module
 */
  public ListTypes: Select[];
  // private client for EStore
  public PrivateClient: PrivateClientInfo;
}

/* ---------------------- CYCLES -------------------------------- */
/**
 * Modèle pour la page de gestion des cycles E-Learning
 */
export class CycleELPModel extends QueovalBase {
  /**
   * Liste des cycles E-Learning
   */
  public ListCycleEL: CycleEL[];
  /**
   * Liste des catalogues E-Learning
   */
  public ListCatalogueEL: CatalogueEL[];
  /**
   * Catalogue E-Learning sélectionné
   */
  public SelectedCatalogueEL: CatalogueEL;
  /**
   * Cycle E-Learning sélectionné
   */
  public SelectedCycleEL: CycleEL;
  /**
   * Liste des chapitres (l'ensemble des chapitres)
   */
  public ListChapterForNewCycle: Chapter[];
  /**
   * Liste des questionnaires "formation"
   */
  public ListQuestFormation: QuestionnaireFormation[];
  /**
   * Info du BO CYCLE EL
   */
  public InfoCycleEL: InfoBo;
}

/* ---------------------- UTILISATEURS -----------------------------*/
/**
 * Modèle pour la page de gestion des apprenants (ou utilisateurs E-Learning)
 */
export class UserELModel extends QueovalBase {
  /**
   * Utilisateur sélectionné
   */
  public UserSelected: UserEL;
  /**
   * Liste des utilisateurs E-Learning
   */
  public ListUsers: UserEL[];
  /**
   * BO CNX_PRTEL
   */
  public BoCnxPrt: BObjectModel;
  /**
   * Infos du BO des apprenants E-Learning (BO_CNX_PRTEL)
   */
  public InfoBoCnxPrtEL: InfoBo;
  /**
   * Modèle de mail sélectionné
   */
  public SelectedModelMail: string;
  /**
   * Liste de tous les cycles
   */
  public ListAllCycles: CycleEL[];
}

/* ---------------------- MODELES DE MAILS -----------------------------*/
/**
// * Modèle pour la page de gestion des modèles de mail --- ANCIENNE VERSION
//// */
//////export class MailELModel extends QueovalBase {
//////  /**
//////   * Modèle de mail sélectionné
//////   */
//////  public ModelMailSelected: ModelMail;
//////  /**
//////   * Liste des modèle de mail
//////   */
//////  public ListModelsMail: ModelMail[];
//////  /**
//////   * Liste de BO
//////   */
//////  public ListBoObject: BoObject[];
//////}

/* ---------------------- MOT DE PASSE -----------------------------*/
/**
 * Modèle pour la page de modification du mot de passe
 */
export class PasswordModel extends QueovalBase {
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Ancien mot de passe
   */
  public OldPassword: string;
  /**
   * Nouveau mot de passe
   */
  public NewPassword: string;
  /**
   * Nom de connexion
   */
  public NameCnx: string;
  /**
   * Texte du message de succès
   */
  public TextSuccess: string;
  /**
   * Texte du message d'erreur
   */
  public TextError: string;
}

/* ---------------------- PARAMETRAGE -----------------------------*/
/**
 * Modèle pour la page de paramétrage
 */
export class ConfigurationELModel extends QueovalBase {
  /**
   * Logo de l'application E-Learning
   */
  public LogoEL: LogoEL;

  /**
  * Logo de la page connection de l'application E-Learning
  */
  public LogoConnectEL: LogoEL;
  /**
  * Réseaux sociaux
  */
  public SocialNetworks: SocialNetworks;
  /**
  * Liste des modules (= parties) --- PLUS UTILISE...
  */
  //////public ModuleList: Module[];
  /**
  * Liste des thèmes
  */
  public ThemeList: string[];
  /**
  * Thème sélectionné
  */
  public SelectedTheme: string;
  /**
   * Formateur par défaut
   */
  public DefaultTrainer: Trainer;

  /**
   * booléen pour savoir si on envoi des mails de notification au formateur
   */
  public SendMailNotif: boolean;
}

/* ---------------------- SCORM -----------------------------*/
/**
 * Modèle scorm
 */
export class ScormModel extends QueovalBase {
  /**
   * Configuration complète (utilisé pour la récupération des sites SCORM)
   */
  public Scorm: Scorm;
  /**
   * url du scorm
   */
  public UrlScorm: string;
}

/* ------------------------------------------------------ */


/* ---------------------- RESULT QUESTIONNAIRES -----------------------------*/

//#region StageQuestionnaire model

export class LessonQuestionnaireModel extends QueovalBase {
  CyclesEL: Array<CycleEL>;
  Chapters: Array<Chapter>;
  Lessons: Array<Lesson>;
  IdCycleELSelected: string;
  IdLessonSelected: string;
  ModelQuestionnaire: string;
  ModelNameQuestionnaire: string;
  LearnerList: Array<LearnerDetail>;
  FilterDateCnxStart: QueovalDate;
  FilterDateCnxEnd: QueovalDate;
  constructor() {
    super();
    this.Chapters = [];
    this.Lessons = [];
  }
}


class Questionnaire {
  model: string;
  type: string;
  titre: string;
  Note: string;
  NoteMax: string;
  NotePassage: string;
  questValid: boolean;
}

//#endregion

//#region DetailLessonQuestionnaire model

//export class DetailLessonQuestionnaireModel extends QueovalBase {

//}

//#endregion

/* --------------------------------------------------------*/
